export default __webpack_public_path__ + "static/media/frame_ja_pc@2x.2e40bdec.png";